module.exports = __webpack_public_path__ + "img/cancel_ae_helper.ef51801e.jpg";